import React from "react";

const Extarctionsvg = ({selected}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <g opacity="1">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.66667 10.8333C9.56367 10.8333 10.2917 10.1053 10.2917 9.20833C10.2917 8.31133 9.56367 7.58333 8.66667 7.58333C7.76967 7.58333 7.04167 8.31133 7.04167 9.20833C7.04167 10.1053 7.76967 10.8333 8.66667 10.8333ZM19.5 20.5833H7.10775L14.6965 14.2512C14.963 14.0248 15.4462 14.0259 15.7073 14.2502L20.5833 18.4102V19.5C20.5833 20.098 20.098 20.5833 19.5 20.5833ZM6.5 5.41667H19.5C20.098 5.41667 20.5833 5.902 20.5833 6.5V15.561L17.1134 12.6013C16.0409 11.6892 14.3628 11.6892 13.3001 12.5948L5.41667 19.1728V6.5C5.41667 5.902 5.902 5.41667 6.5 5.41667ZM19.5 3.25H6.5C4.70817 3.25 3.25 4.70817 3.25 6.5V19.5C3.25 21.2918 4.70817 22.75 6.5 22.75H19.5C21.2918 22.75 22.75 21.2918 22.75 19.5V6.5C22.75 4.70817 21.2918 3.25 19.5 3.25Z"
          fill={selected  ? "#ea5f18" : "white"}
        />
      </g>
    </svg>
  );
};

export default Extarctionsvg;
